document.addEventListener("DOMContentLoaded", () => {

  const productGrid = document.querySelector("#product-grid");
  if (!productGrid) return;

  const products = [...productGrid.querySelectorAll(".product-item")];
  const tabs = [...document.querySelectorAll(".price-tab-btn")];
  const viewMoreBtn = document.querySelector(".view-more-btn");
  const viewMoreWrap = document.querySelector(".view-more-wrap");
  const noProducts = document.querySelector("#no-products-msg");

  const PRODUCTS_PER_PAGE = 50;

  let currentPage = 1;
  let filteredProducts = [];

  function getActiveMaxPrice() {
    const activeTab = document.querySelector(".price-tab-btn.active");
    return activeTab
      ? parseFloat(activeTab.dataset.maxPrice)
      : Infinity;
  }

  function hideEmptyTabs() {
    tabs.forEach(tab => {
      const maxPrice = parseFloat(tab.dataset.maxPrice);
      const hasProducts = products.some(product => {
        return Number(product.dataset.price) <= maxPrice;
      });
      if (!hasProducts) {
        tab.style.display = "none";
      }
    });

    const visibleTabs = [...tabs].filter(tab => tab.style.display !== "none");
    tabs.forEach(tab => tab.classList.remove("active"));
    if (visibleTabs.length) {
      visibleTabs[0].classList.add("active");
    }
  }

  function filterProducts() {
    const maxPrice = getActiveMaxPrice();

    filteredProducts = products
      .filter(product => Number(product.dataset.price) <= maxPrice)
      // sort low to high
      .sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));

    currentPage = 1;

    renderProducts();
  }

  function renderProducts() {

    products.forEach(product => {
      product.classList.add("is-hidden");
    });

    const visibleSlice = filteredProducts.slice(0, currentPage * PRODUCTS_PER_PAGE);

    // Reorder DOM to match sorted order
    visibleSlice.forEach(product => {
      product.classList.remove("is-hidden");
      productGrid.appendChild(product);
    });

    if (viewMoreWrap) {
      viewMoreWrap.style.display =
        filteredProducts.length > currentPage * PRODUCTS_PER_PAGE
          ? "block"
          : "none";
    }

    if (noProducts) {
      noProducts.style.display =
        filteredProducts.length
          ? "none"
          : "block";
    }

  }

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(btn => btn.classList.remove("active"));
      tab.classList.add("active");
      filterProducts();
    });
  });

  if (viewMoreBtn) {
    viewMoreBtn.addEventListener("click", () => {
      currentPage++;
      renderProducts();
    });
  }

  hideEmptyTabs(); 
  filterProducts();

});